import { defineMessages } from 'react-intl';

const prefix = 'placesAutoComplete';

export const placesAutoCompleteMsgs = defineMessages({
    searchPlaces: {
        id: `${prefix}.searchPlaces`,
        defaultMessage: 'Search Places ...',
    },
});
